import { Pipe, PipeTransform } from '@angular/core';

import { HelpersInterface } from '@core/interfaces';

const matches = (item: { id: number; name?: string }, query: string): boolean =>
  !!item.name?.toLowerCase().includes(query) || item.id.toString().includes(query);

@Pipe({
  name: 'endpointGroupsSearch',
  standalone: false,
})
export class EndpointGroupsSearchPipe implements PipeTransform {

  transform(groups: HelpersInterface.IGroupList[], search = ''): HelpersInterface.IGroupList[] {
    const query = search.trim().toLowerCase();

    if (!query) {
      return groups;
    }
    return groups.filter(group => matches(group, query) || !!group.endpoints?.some(endpoint => matches(endpoint, query)));
  }
}

@Pipe({
  name: 'groupEndpointsSearch',
  standalone: false,
})
export class GroupEndpointsSearchPipe implements PipeTransform {

  // The group can be listed because its own name matched, then all of its endpoints stay
  transform(endpoints: HelpersInterface.IGroupEndpoint[], search = ''): HelpersInterface.IGroupEndpoint[] {
    const query = search.trim().toLowerCase();

    if (!query) {
      return endpoints;
    }
    const matched = endpoints.filter(endpoint => matches(endpoint, query));

    return matched.length ? matched : endpoints;
  }
}
